<div class="container">
    <div class="voucher-container">
        <button type="button" class="btn-back"  (click)="goBackFunction()" fill="clear">
            <p>
              <ion-icon name="arrow-back-outline"></ion-icon>
              &nbsp;&nbsp;&nbsp;
              <span class="voucher-goBack-text"> {{voucherProperties.goBackText}} </span>
            </p>
          </button>
        <div class="icon-container">
            <div class="ion-justify-content-center ion-flex">
                <img [src]="voucherProperties.srcImage" class="success-image" alt="successVoucher">
            </div>
        </div>
        <div class="voucher-title">
            <h1 class="ion-text-center">
                {{voucherProperties.titleSuccess}}
            </h1>
        </div>
        <div class="voucher-paragraph">
            <h3 class="bold">{{ voucherProperties.subtitleSucces }}</h3>
            <h3>{{ voucherProperties.infoSucces }}</h3>
        </div>
        <div class="voucher-paragraph">
            <h3 class="bold">{{ voucherProperties.subtitleSuccesEmail }}</h3>
            <div class="success-email">
                <ng-container *ngIf="hasEmail; else nothasEmail">
                    <h4 >También lo enviamos a tu correo <b>{{ clientEmail }}</b>. Si no lo encuentras en tu bandeja principal, por favor, revisa el spam</h4>
                </ng-container>
                <ng-template #nothasEmail>
                    <h4>Aún no registras un correo para recibir tus comprobantes, por favor agrega uno en<a class="link" (click)="goToYourData()">Tus datos</a></h4>
                </ng-template>
            </div>
            
        </div>
        <div class="voucher-container-info">
            <div class="voucher-info">
                <div class="voucher-label">
                    <h3 >
                        Nº de solicitud:
                    </h3>
                </div>
                <div class="voucher-data">
                    <h3 class="bold-500 ">
                        {{ solicitudResponse.caseNumber }}
                    </h3>
                </div>

            </div>
            <div class="voucher-info">
                <div class=" voucher-label">
                    <h3 >
                        Tipo de solicitud:
                    </h3>
                </div>
                <div class="voucher-data">
                    <h3 class="bold-500 ">
                        {{ solicitudResponse.subject }}
                    </h3>
                </div>
                
                
            </div>
            <div class="voucher-info">
                <div class="voucher-label">
                    <h3 >
                        Fecha de solicitud:
                    </h3>
                </div>
               <div class="voucher-data">
                <h3 class="bold-500 ">
                    {{ solicitudResponse.caseDate }}
                </h3>
               </div>
            </div>
        </div>
        <button class="btn primary primary-button" (click)="goToAccounts()">
            {{ voucherProperties.buttonText }}
            <div class="spinner-wrapper">
                <ion-spinner name="crescent" slot="end" *ngIf="loading" color="light"></ion-spinner>
            </div>
        </button>
    </div>

</div>